export default __webpack_public_path__ + "static/media/arunimamam.d6c80e99.jpg";